import * as React from "react";
import { App } from "../../components/App";

export interface VersionNoteEditorProps {
  eventMasterId: number;
  versionId: number;
  note: string;
}

export const VersionNoteEditorApp = (props: VersionNoteEditorProps) => {
  return <App {...props} />;
};
